import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import error from '@/components/404.vue'
import Schools from '@/views/Schools.vue'
import Locator from '@/views/Locator.vue'
import Visualizer from '@/views/Visualizer.vue';
import Enrollment from '../views/Enrollment.vue'
import FAQ from '@/views/FAQ.vue'
import Features from '@/views/Features.vue'
import Contact from '@/views/Contact.vue'

Vue.use(Router)

let categories = []
store.state.search.categories.forEach((c) => {
  if (categoryIDs.indexOf(c.id) !== -1) {
    categories.push({
      id: c.id,
      name: c.name,
      features: []
    })
    c.features.forEach((f) => {
      if (featureIDs.indexOf(f.id) !== -1) {
        for (let i = 0; i < categories.length; i++) {
          if (categories[i].id === f.category_id) {
            categories[i].features.push({
              id: f.id,
              name: f.name
            })
          }
        }
      }
    })
  }
})


function passSchoolId(route) {
  return {
    school_id: route.params.school_id || null
  }
}

function getCategories() {
  return {
    categories: store.state.search.categories
  }
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/schools',
      component: Schools,
      name: 'schools'
    },
    {
      path: '/',
      component: Locator,
      name: 'locator'
    },
    {
      path: '/el',
      component: Locator,
      name: 'elementary'
    },
    {
      path: '/jh',
      component: Locator,
      name: 'jrHigh'
    },
    {
      path: '/hs',
      component: Locator,
      name: 'highSchool'
    },
    {
      path: '/enrollment',
      component: Enrollment,
      name: 'enrollment',
      props: passSchoolId
    },
    {
      path: '/faq',
      component: FAQ
    },
    {
      path: '/features',
      component: Features,
      props: getCategories
    },
    {
      path: '/contact',
      component: Contact
    },
    // {
    //   path: '/visualizer',
    //   component: Visualizer,
    //   name: 'visualizer'
    // },
    {
      path: '/:pathMatch(.*)',
      component: error,
      name: '404'
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})

router.beforeEach((to, from, next) => {
  store.commit('resetCompare')
  switch (to.path) {
    case '/':
      gtag('config', 'UA-113871208-1', {
        'page_path': '/'
      })
      break
    case '/schools':
    case '/schools/':
      gtag('config', 'UA-113871208-1', {
        'page_path': '/schools'
      })
      break
    case '/locator':
    case '/locator/':
      gtag('config', 'UA-113871208-1', {
        'page_path': '/locator'
      })
      break
    case '/enrollment':
    case '/enrollment/':
      gtag('config', 'UA-113871208-1', {
        'page_path': '/enrollment'
      })
      break
    case '/faq':
    case '/faq/':
      gtag('config', 'UA-113871208-1', {
        'page_path': '/faq'
      })
      break
    case '/features':
    case '/features/':
      gtag('config', 'UA-113871208-1', {
        'page_path': '/features'
      })
      break
    case '/contact':
    case '/contact/':
      gtag('config', 'UA-113871208-1', {
        'page_path': '/contact'
      })
      break
  }
  next()
})

export default router
